export enum ActionType {
  Casino = 1,
  Deposit = 2,
  SportsBet = 3,
}
